import { createSlice } from "@reduxjs/toolkit";
import {
  getAllBusinesses,
  createNewBusiness,
  onUpdateBusiness,
  BusinessBySlugId,
} from "./thunk";

export const initialState = {
  businesses: [],
  isCreated: false,
  isBusinessSuccess: false,
  businessBySlugId: {},
  isBusinessBySlugIdSuccess: false,
  isLoading: false,
  error: "",
};

const businessSlice = createSlice({
  name: "business",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllBusinesses.pending, (state, action) => {
        state.isLoading = true;
        state.isBusinessSuccess = false;
      })
      .addCase(getAllBusinesses.fulfilled, (state, action) => {
        state.isLoading = false;
        state.businesses = action.payload?.items;
        state.isBusinessSuccess = true;
      })
      .addCase(getAllBusinesses.rejected, (state, action) => {
        state.isLoading = false;
        state.isBusinessSuccess = false;
      })
      .addCase(createNewBusiness.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(createNewBusiness.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isCreated = true;
      })
      .addCase(createNewBusiness.rejected, (state, action) => {
        state.isLoading = false;
      })
      .addCase(BusinessBySlugId.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(BusinessBySlugId.fulfilled, (state, action) => {
        state.isLoading = false;
        state.businessBySlugId = action.payload?.data;
        state.isBusinessBySlugIdSuccess = true;
      })
      .addCase(BusinessBySlugId.rejected, (state, action) => {
        state.isLoading = false;
        state.isBusinessBySlugIdSuccess = false;
      })
      .addCase(onUpdateBusiness.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(onUpdateBusiness.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(onUpdateBusiness.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default businessSlice.reducer;
